import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { RolodexEntryPatchJson, WorldPosition } from 'types'

import { KVMessageDef } from './index'

export function roofOutlineGenerationResult() {
  return {
    type: 'roofOutlineGenerationResults',
    requiredData: ['segments'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      if (!json.segments) return

      const segments = json.segments as WorldPosition[]

      const patchData: RolodexEntryPatchJson = {
        id: kv.kestrelModel?.id ?? '',
        data: {
          boundingSegments: segments,
        },
      }
      kv.rolodexPatch([patchData])
    },
  } as KVMessageDef
}
